(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["beauty-party-experiences"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('beauty-party-slideshow')) {
    customElements.define('beauty-party-slideshow', class extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.bpe__slide'));
        this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.pause = () => this.stop();
        this.resume = () => this.start();
        this.addEventListener('mouseenter', this.pause);
        this.addEventListener('mouseleave', this.resume);
        this.addEventListener('focusin', this.pause);
        this.addEventListener('focusout', this.resume);
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        this.removeEventListener('mouseenter', this.pause);
        this.removeEventListener('mouseleave', this.resume);
        this.removeEventListener('focusin', this.pause);
        this.removeEventListener('focusout', this.resume);
      }

      start() {
        if (this.slides.length < 2 || this.reduceMotion.matches || this.timer) return;
        const interval = Number(this.dataset.interval) || 6000;
        this.timer = window.setInterval(() => this.show(this.index + 1), interval);
      }

      stop() {
        window.clearInterval(this.timer);
        this.timer = null;
      }

      show(nextIndex) {
        this.slides[this.index].classList.remove('is-active');
        this.index = nextIndex % this.slides.length;
        this.slides[this.index].classList.add('is-active');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
